<template>
  <v-dialog :value="value" width="600" persistent>
    <div class="dialog-header-container d-flex align-center">
      <div class="dialog-header-text">{{$t('menuLayout.dialog.changePassword')}}</div>
      <div class="dialog-header-btn" @click="$emit('closeDialog')">
        <v-icon class="pl-1" size="24" color="white">md mdi-close</v-icon>
      </div>
    </div>
    <v-card class="dialog-card">
      <div class="d-flex justify-space-between">
      <div class="dialog-icon-container">
        <dr-svg image="PAROL3" :size="24" color="#737373" class="mt-2"></dr-svg>
      </div>
      <div>
        <div class="px-4 pt-2 d-flex justify-space-between">
          <div class="dialog-change-login-text pr-5">
            {{$t('menuLayout.dialog.login')}}
          </div>
          <div class="dialog-change-password-input-container">
            <input :value="obj.login" @input="changeValue($event.target.value)" class="dialog-change-password-input dialog-change-password-input-login" disabled="disabled"/>
          </div>
        </div>
        <div class="px-4 pt-2 d-flex justify-space-between">
          <div class="dialog-change-login-text pr-5">
            {{$t('menuLayout.dialog.oldPassword')}}
          </div>
          <div class="dialog-change-password-input-container">
            <input type="PASSWORD" :value="obj.oldPassword" @input="changeValue($event.target.value, 'oldPassword')" class="dialog-change-password-input"/>
          </div>
        </div>
        <div class="px-4 pt-2 d-flex justify-space-between">
          <div class="dialog-change-login-text pr-5">
            {{$t('menuLayout.dialog.newPassword')}}
          </div>
          <div class="dialog-change-password-input-container">
            <input type="PASSWORD" :value="obj.newPassword" @input="changeValue($event.target.value, 'newPassword')" class="dialog-change-password-input"/>
          </div>
        </div>
        <div class="px-4 pt-2 d-flex justify-space-between">
          <div class="dialog-change-login-text pr-5">
            {{$t('menuLayout.dialog.confirmPassword')}}
          </div>
          <div class="dialog-change-password-input-container">
            <input type="PASSWORD" :value="obj.confirmPassword" @input="changeValue($event.target.value, 'confirmPassword')" class="dialog-change-password-input"/>
          </div>
        </div>
        <div class="px-4 pt-2 d-flex dialog-change-login-text dialog-change-login-attention">
          {{$t('menuLayout.dialog.passwordLength')}}
        </div>
        <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="var(--accentColor)"
          text
          @click="changePassword"
        >
          {{$t('menuLayout.dialog.change')}}
        </v-btn>
      </v-card-actions>
      </div>
      
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { MainMenuApi as api } from '../../api/api'
import {notificationApi} from '../../../api/notificationApi'
export default {
  props: ['value'],
  data: () => ({
    obj: {
      login: '',
      oldPassword: '',
      newPassword: '',
      confirmPassword: ''
    }
  }),
  components: {
    'dr-svg': () => import('../customWidgets/dr-svg.vue')
  },
  created() {
    this.obj.login = this.$store.getters.userLogin
  },
  methods: {
    changeValue(value, key) {
      this.obj[key] = value
    },
    async changePassword() {
      if (this.obj.newPassword !== this.obj.confirmPassword) {
        notificationApi.showError({ text: this.$t('menuLayout.dialog.confirmPasswordError') })
        return
      }

      let response = await api.changePassword(this.obj)
      let result = response.data.iTEnterpriseMenuMutation.changePassword
      if (result.success) {
        this.$emit('closeDialog')
        return
      }
      notificationApi.showError({ text: result.errorMessage })
    }
  }
}
</script>
<style>
.dialog-change-password-input {
  border-color: var(--accentColor) !important;
  font-size: 14px;
  font-family: Roboto, Arial, Helvetica;
  color: black !important;
  border-radius: 0px;
  background-color: transparent !important;
  width: 336px;
  border-bottom-style: solid;
  border-bottom-width: 1px;
}
.dialog-change-password-input:focus {
  outline: none;
  border-bottom: 2px solid var(--accentColor) !important;
  border-bottom-width: -2px;
}

.dialog-change-password-input-container {
  font-size: 14px;
  line-height: normal;
  font-family: Roboto, Arial, Helvetica;
  color: #404040;
  padding-right: 36px !important;
  margin-bottom: -2px;
}
.dialog-icon-container {
  margin-left: auto;
  margin-right: auto;
}
.dialog-change-login-text {
  font-family: Roboto, Arial, Helvetica;
  cursor: default;
  margin: 0px 3px;
  font-size: 11.9px;
}
.dialog-change-login-attention {
  font-weight: 700;
  color: rgb(64, 64, 64);
}

.dialog-change-password-input-login {
  border-bottom-style: dashed;
  border-bottom-color: #dfdfdf !important;
  font-family: Roboto, Arial, Helvetica;
  color: rgba(0, 0, 0, 0.55) !important;
}

</style>